var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ProductPayTemplate", {
    attrs: { title: "购买VIP", type: _vm.type },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }